$(function recipeIntegration() {
    var $recipeIntegrationBox = $('#recipe-integration-box');
    var $recipeIntegrationPagination = $('#recipe-integration-pagination');
    var dataRiSliderTracking = 'data-ri-slider-tracking';
    var dataRiClickTracking = 'data-ri-click-tracking';
    var xsBreakPoint = 600;
    var slickConfig = {
        dots: true,
        appendArrows: $recipeIntegrationPagination,
        appendDots: $recipeIntegrationPagination,
        nextArrow: '<button type="button" class="slick-next"><div class="button__icon--image-slider"><span class="is-visually-hidden">nächstes Element</span><svg class="icon__arrow--image-slider" width="16" height="27" viewBox="0 0 16 27" xmlns="http://www.w3.org/2000/svg"><path d="M.3 24.76c0-.233.09-.44.27-.62l10.6-10.6L.57 2.936C.39 2.757.3 2.55.3 2.317c0-.235.09-.44.27-.62L1.917.346c.18-.18.387-.27.62-.27.234 0 .44.09.62.27l12.572 12.57c.18.18.27.388.27.622 0 .232-.09.44-.27.62L3.16 26.73c-.18.18-.388.27-.62.27-.235 0-.442-.09-.622-.27l-1.35-1.35C.39 25.203.3 24.996.3 24.76z" /></svg></div></button>',
        prevArrow: '<button type="button" class="slick-prev"><div class="button__icon--image-slider"><span class="is-visually-hidden">vorheriges Element</span><svg class="icon__arrow--image-slider" width="16" height="27" viewBox="0 0 16 27" xmlns="http://www.w3.org/2000/svg"><path d="M15.7 2.24c0 .233-.09.44-.27.62l-10.6 10.6 10.6 10.603c.18.18.27.387.27.62 0 .235-.09.44-.27.62l-1.348 1.35c-.18.18-.387.27-.62.27-.234 0-.44-.09-.62-.27L.27 14.083c-.18-.18-.27-.388-.27-.622 0-.232.09-.44.27-.62L12.84.27c.18-.18.388-.27.62-.27.235 0 .442.09.622.27l1.35 1.35c.18.178.268.385.268.62z" /></svg></div></button>',
        autoplay: true,
        autoplaySpeed: 4500
    };

    $recipeIntegrationBox.find('li').sort(function() {
        return Math.round(Math.random()) - 0.5;
    }).detach().appendTo($recipeIntegrationBox);


    function gaTrackTeaser(teaser) {
        if (window.ck && window.ck.tracking) {
            window.ck.tracking.trackTeaser(JSON.parse(teaser));
        }
    }

    function initTrackEvent(element, sliderTracking, clickTracking) {
        element.on('init', function(event, slick) {
            var $currentSlide = $(slick.$slides[slick.currentSlide]);
            if ($currentSlide.attr(sliderTracking) != null) {
                gaTrackTeaser($currentSlide.attr(sliderTracking));
            }
        });

        element.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            var $nextSlide = $(slick.$slides[nextSlide]);
            if ($nextSlide.attr(sliderTracking) != null) {
                gaTrackTeaser($nextSlide.attr(sliderTracking));
            }
        });

        element.find('[' + clickTracking + ']').on('click', function(event) {
            var teaserData = $(event.currentTarget).parent('[' + sliderTracking + ']').attr(sliderTracking);
            var eventData = '{ "type":"event", "name":"click", "target":' + teaserData + '}';
            if (window.ck && window.ck.tracking) {
                window.ck.tracking.trackEvent(JSON.parse(eventData));
            }
        });
    }

    function slickOnMobile(slider, settings, sliderTracking, clickTracking) {
        $(window).on('load resize', function() {
            if ($(window).width() > xsBreakPoint) {
                if (slider.hasClass('slick-initialized')) {
                    slider.slick('unslick');
                }
                return
            }
            if (!slider.hasClass('slick-initialized')) {
                initTrackEvent(slider, sliderTracking, clickTracking);
                return slider.slick(settings);
            }
        });
    };

    slickOnMobile($recipeIntegrationBox, slickConfig, dataRiSliderTracking, dataRiClickTracking);
});